import {MessagesWithIndexSignature} from '@/types/generic.types';

import {errorMessages} from './messages';

const RECOVER_PASSWORD_LINK = '/login/recover';
const typedErrorMessages = errorMessages as MessagesWithIndexSignature;

export {RECOVER_PASSWORD_LINK, typedErrorMessages};
